import { render, staticRenderFns } from "./LawcaseTableForm.vue?vue&type=template&id=60e692f6&scoped=true&"
import script from "./LawcaseTableForm.vue?vue&type=script&lang=js&"
export * from "./LawcaseTableForm.vue?vue&type=script&lang=js&"
import style0 from "./LawcaseTableForm.vue?vue&type=style&index=0&id=60e692f6&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e692f6",
  null
  
)

export default component.exports